<template>
  <div class="problem-button">
    <button type="button" class="btn btn-default btn-sm btn-round" data-toggle="modal"
            data-target="#exampleModalCenter"><i class="fas fa-question"></i></button>
    <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog"
         aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalCenterTitle">Any difficulties?</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" v-html="taskHelpInfo"></div>
          <div class="modal-footer">
            <button type="button" class="btn btn-blue btn-small" data-dismiss="modal"
                    aria-label="Close">
              Got it!
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "HelpButton",
        props: ['taskHelpInfo']
    }
</script>

<style scoped>

</style>
